import React, { useState, useMemo, useEffect } from 'react'
// import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { PersonColumns } from '../components/person_columns'
import MainLayout from '../layout/MainLayout'
import BasicTable from '../components/BasicTable'
import UserAdministrationNew from '../new_pages/UserAdministrationNew';
import useDeleteWithConfirmation from '../components/useDeleteWithConfirmation';
import DeleteConfirmation from '../components/DeleteConfirmation';
import { formatTimestampNow } from '../utils/functions';

import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import der Icons für Passwort

import { handleFocus, handleBlur, validateField } from '../utils/functions';
import IncorrectInputModalModal from '../components/IncorrectInputModal'; // Importiere die Modal-Komponente zur Ausgabe bei Fehleingaben vom User
import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/UserAdministrationArea.css'

function UserAdministrationPage() {
  // const navigate = useNavigate();
  
  const [persons, setPersons] = useState([]);
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);

  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false); // für Popup Neuer Datensatz
  // Zustandsvariable, um zu ueberpruefen, welches Symbol geklickt wurde
  const [clickedAnyIcon, setClickedAnyIcon] = useState(false);
  const [newSelectedRowID, setNewSelectedRowID] = useState(null);
  
  const [copiedData, setCopiedData] = useState(null); // Zustand für kopierte Daten
  const [showPassword, setShowPassword] = useState(false); // State zum Umschalten der Passwortsichtbarkeit

  const [errors, setErrors] = useState({}); // Zustand für Fehler pro Feld
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false); // Zustand für die Anzeige des Modals

  const id_institution = window.localStorage.getItem('id_institution');
  const id_role = window.localStorage.getItem('id_role');
  const id_person = window.localStorage.getItem('id_person');

  const access_token = window.localStorage.getItem('access_token');
  // const warningThreshold = window.localStorage.getItem("warning_threshold");

  // Festlegen der Pfade für das Rollenbild
  const imageUrl = ('/roles.png')


  /* post-State Objekt, um Daten zu speichern, die vom Nutzer eingegeben werden */
  const [post, setPost] = useState({
    id_person: '',
    lastname: '',
    firstname: '',
    username: '',
    email: '',
    password: '',
    role_name: '',
    institution_name: '',
    timestamp: '',
    can_change_person: false
  });
  

  // Funktion zum Leeren der Eingabefelder
  const clearFields = () => {
    setPost({
      // person:
      id_person: '',
      lastname: '',
      firstname: '',
      username: '',
      email: '',
      password: '',
      role_name: '',
      institution_name: '',
      timestamp: '',
      can_change_person: false
    });
    setErrors({});
  };
    

  // wird beim Rendern der Komponente ausgeführt
  useEffect(() => {
    fetchPersons();
    fetchRoleOptions();
    fetchInstitutionOptions();
  }, []);


  /*useEffect(() => {
    const checkTokenExpiry = () => {
      console.log("Initializing token expiry check...");

      const expiresAt = window.localStorage.getItem("expires_at");
      if (!expiresAt) return;

      const expiryDate = new Date(expiresAt);
      const now = new Date();
      const timeLeft = expiryDate - now;

      if (timeLeft <= 0) {
        logoutUser();
      } else if (timeLeft <= parseInt(warningThreshold, 10)) { // Warnschwelle von 1 Minuten
        // Zeige Warnung
        showExpiryWarning();
      }        
    };

    const logoutUser = () => {
      console.log("Logging out user due to token expiry.");
      window.localStorage.clear(); // Bereinige gespeicherte Daten
      navigate('/'); // Weiterleitung zur Login-Seite
      
    };
  
    const showExpiryWarning = () => {
      console.log("Warning out user due to token expiry.");
      if (!window.localStorage.getItem("warned_about_expiry")) {
        alert("Ihre Sitzung läuft bald ab. Bitte speichern Sie Ihre Arbeit.");
        window.localStorage.setItem("warned_about_expiry", true); // Verhindert wiederholte Warnungen
      }
    };
   

    // Überwachung alle 5 Sekunden
    const intervalId = setInterval(checkTokenExpiry, 5 * 1000); //5 Sekunden
  
    return () => clearInterval(intervalId); // Cleanup bei unmount
  }, [navigate]); */
  

  // Anzeige der Eingabefelder unter der Tabelle zum Aendern
  const fields = [
    { name: 'username', label: 'Benutzername', type: 'text', validate: { required: true} },
    { name: 'lastname', label: 'Nachname', type: 'text', validate: { required: true} },
    { name: 'firstname', label: 'Vorname', type: 'text', validate: { required: true} },
    { name: 'email', label: 'E-Mail', type: 'email', validate: { email: true, required: true} },
    { name: 'password', label: 'Passwort', type: 'password', validate: { required: true} },
    { name: 'role_name', label: 'Rolle', type: 'select', validate: { required: true} },
    { name: 'institution_name', label: 'Institution', type: 'text' },
  ];


  // Funktion, um Benutzereingaben in Formularfeldern zu verarbeiten
  const handleInput = (event) => {
    const { name, value, type, checked } = event.target;
    setPost({ ...post, [name]: type === 'checkbox' ? checked : value });
  }
 

  const fetchPersons = async () => {
    try {
      const param = {
        headers: {
          'idRole': id_role,
          'idInstitution': id_institution,
          'idPerson': id_person,
          'Authorization': `Bearer ${access_token}`
        }
      }; 
      
      const response = await axios.get(
        `${url_root}/get_all_knit_person_to_role_and_institution_ext`, param
      );

      setPersons(response.data);

      return response.data.knit_person || [];
    } catch (error) {
      console.error('Error fetching data:', error);
      return []; // Rückgabe eines leeren Arrays im Fehlerfall
    }
  };


  // Funktion zum Abrufen der Institutionen-Daten
  const fetchInstitutionOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };

      const response = await axios.get(`${url_root}/get_all_knit_institution`, param);
      setInstitutionOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der institution options:', error);
    }
  };
  

  // Funktion zum Abrufen der Rollen-Daten
  const fetchRoleOptions = async () => {
    try {
      const param = {
        headers: {
          'idRole': id_role,
          'Authorization': `Bearer ${access_token}`
        }
      }; 
      const response = await axios.get(`${url_root}/get_all_knit_role`, param);
      setRoleOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der roleOptions:', error);
    }
  };


  // Vermeidung von Zugriff auf Eigenschaften von null oder leeres Array
  const knitPersonExtArray = persons && persons.knit_person; 

  // Verwende das knitPersonExtArray als Daten für die Tabelle
  const data = useMemo(() => knitPersonExtArray || [], [knitPersonExtArray]);

  // Definiere den Accessor für die BasicTable
  const accessor = 'id_person';


  // Funktion zur Uebertragung des Datensatzes in die Eingabefelder zum Aendern
  const handleButtonChange = (id) => {
    if (!id) {
      return;
    }

    // Fehler zuruecksetzen, falls vom vorigen Datensatz noch vorhanden
    setErrors({});

    // Datensatz der übergebenen id_person ermitteln
    const changePersonData = data.find(row => row.id_person === id);

    // Wenn kein Datensatz gefunden wird, abbrechen
    if (!changePersonData) {
      return;
    }

    // Aktuellen Zeitstempel abrufen und formatieren
    const timestamp = formatTimestampNow();

    setPost({
      id_person: changePersonData.id_person,
      lastname: changePersonData.lastname,
      firstname: changePersonData.firstname,
      username: changePersonData.username, //???
      /* auskommentiert, so dass das verschluesselte PW aus DB nicht angezeigt wird, 
        Aenderung neues PW wird trotzdem gespeichert */
      //password: changePersonData.password, 
      email: changePersonData.email,
      role_name: changePersonData.role_name,
      institution_name: changePersonData.institution_name,
      timestamp: timestamp, // aktueller timestamp
      //timestamp: changePersonData.timestamp,
    })
  };


  // Funktion zum Speichern des geaenderten Datensatzes
  const handleSave = async (id) => {
    try {
      if (id === "" || id === undefined) {
        setErrorMessage("Bitte wählen Sie einen Nutzer zum Ändern aus oder legen Sie mit NEU einen neuen Nutzer an.");
        setShowErrorModal(true);
        return;
      }

      // Ueberpruefung, ob es noch Fehleingaben gibt
      const hasErrors = Object.values(errors).some(error => error !== '');

      if (hasErrors) {
        // Zeige das Modal-Popup, wenn noch Fehler vorhanden sind
        setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
        setShowErrorModal(true);
        return; // Stoppe das Speichern, bis die Fehler behoben sind
      }

      setErrors({});

      // Erstellen einer Kopie des Datensatzes, um ihn zu bearbeiten
      const modifiedPost = { ...post };

      await axios.put(`${url_root}/modify_knit_person_to_id_ext`, modifiedPost,
        {
          headers: {
              'Authorization': `Bearer ${access_token}`
          }
        }
      );
      
      //id = response.data.id_person; // 'id' auf die neu erstellte ID setzen
      newSaveID(id); // Zeile des geänderten Datensatzes bleibt in der BasicTable markiert
      
      fetchPersons(); // Tabelle aktualisieren
      setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, d.h. icon wird wieder blau
      clearFields();
     } catch (error) {
      console.error('Error saving data:', error);
    }
  };


  // Abfrage zum Loeschen Datensatz als popup in extra Komponente und use Hook ausgelagert:
  const deleteApiUrl = `${url_root}/delete_knit_person_to_id`;
  // benutzerdefinierter Hook useDeleteWithConfirmation kapselt die Loeschlogik und den Zustand des Bestaetigungs-Popups
  const {
    isDeletePopupOpen,
    handleButtonDelete,
    handleConfirmDelete,
    closeDeletePopup,
  } = useDeleteWithConfirmation(deleteApiUrl, fetchPersons, clearFields);


  // Funktion zum Oeffnen des Popups für das Hinzufuegen eines neuen Datensatzes
  const openNewEntryPopup = () => {
    setClickedAnyIcon(true); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
    setIsNewPopupOpen(true);
  };


  // Funktion zum Schliessen des Popups für neue Eintraege
  const closeNewPopup = () => {
    setCopiedData(null); // Setze copiedData auf null, Eingabefelder werden geleert
    setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
    setIsNewPopupOpen(false);
    clearFields();
  };


  // Funktion zum Markieren des neuen Datensatzes in BasicTable
  const newSaveID = (id) => {
    setNewSelectedRowID(id) // newSelectedRowID wird auf den Wert der person_id gesetzt
  };

  
  // Daten aus anderer Tabelle
  const filteredDataInstitution = institutionOptions && institutionOptions.knit_institution ? institutionOptions.knit_institution.filter(item => item.id_institution !== 0) : [];
  const institutionOptionsSet = new Set(filteredDataInstitution.map(item => item.name)); // Eindeutige Institutsbezeichnungen erhalten
  const sortedInstitutionOptions = Array.from(institutionOptionsSet).sort(); // Array erstellen und aufsteigend sortieren
  
  const filteredDataRole = roleOptions && roleOptions.knit_role ? roleOptions.knit_role.filter(item => item.id_role !== 0) : [];
  const roleOptionsSet = new Set(filteredDataRole.map(item => item.name)); // Eindeutige Rollenbezeichnungen erhalten
  const sortedRoleOptions = Array.from(roleOptionsSet).sort(); // Array erstellen und nach Rollenname sortieren
  
  
  return (
    <MainLayout openNewEntryPopup={openNewEntryPopup} showAllButton={false}>
      <BasicTable 
        columns={PersonColumns} 
        accessor={accessor}
        data={data} 
        handleButtonChange={handleButtonChange}
        handleButtonDelete={handleButtonDelete}
        clearFields={clearFields} // Hier wird die Funktion als Prop übergeben
        newSaveID={newSelectedRowID} // Funktion zum Markieren des neuen Datensatzes in Tabelle uebergeben
        isAnyIconClicked={clickedAnyIcon}
        showDatasheetIcon={false} // Datasheet icon wird in Tabelle angezeigt
      />
      <div className='area-under-table-admin'>
        <div className='area-change-admin'>
          <div className='box-title-admin'>
            <h3>Hier können Sie die Nutzerdaten ändern:</h3>
          </div>

          {fields.map(field => (
          <div key={field.name} className="change-input-row-admin"> 
            <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>  
            
            <div className="input-with-unit-admin">
              {field.name === 'password' ? (
                <div className="password-input-container">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name={field.name}
                    value={post[field.name]}
                    onChange={handleInput}
                />
                <div
                  className="password-toggle-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </div>
              </div>


            ) : field.type === 'select' && field.name === 'role_name' ? (
            <>
              <select 
                onChange={handleInput} 
                name={field.name} 
                value={post[field.name]}
                onFocus={(event) => handleFocus(event, setErrors)}
                onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                  validateField(name, value, rules, setErrors))}
              >
                  <option value=""></option>
                  {sortedRoleOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                  {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
                  {errors[field.name] && (
                        <span className="error-message">{errors[field.name]}</span>
                      )}
            </>
              ) : (
                <>
                  <input
                    type={field.type} // Texteingabefelder
                    name={field.name}
                    value={post[field.name]}
                    onChange={handleInput}
                    readOnly={field.name === 'institution_name'  || field.name === 'username'}

                    onFocus={(event) => handleFocus(event, setErrors)}
                    onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                      validateField(name, value, rules, setErrors))}
                  /> 
                  {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}                 
                </>
              )}
            </div>
          </div>
        ))}


          <div className='area-change-button-admin'>
            <button onClick={() => clearFields()}>ABBRECHEN</button>
            <button onClick={() => handleSave(post.id_person)}>SPEICHERN</button>       
          </div>
        </div> {/*Ende area-under-table*/}

        <div className='area-image-admin'>
          {/* Anzeigen des Bildes, wenn imageUrl vorhanden ist */}
          {imageUrl && <img src={imageUrl} alt="kein Foto vorhanden" />}
        </div> {/*Ende area-image*/}

      </div>   
           

      {/* für popup NEU */}
      {isNewPopupOpen && (
        <div className="new-popup-overlay">
          <div className="new-popup-content">
            <span onClick={closeNewPopup} className="new-popup-close">
              &times;
            </span>
            <UserAdministrationNew
              closeNewPopup={closeNewPopup}
              fields={fields} // Eingabefelder für neuen Datensatz
              sortedRoleOptions={sortedRoleOptions}
              sortedInstitutionOptions={sortedInstitutionOptions}
              fetchPersons={fetchPersons}
              copiedData={copiedData}
              newSaveID={newSaveID}
              formatTimestampNow={formatTimestampNow}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              validateField={validateField}
              setErrors={setErrors}
              errors={errors}
              setErrorMessage={setErrorMessage}
              setShowErrorModal={setShowErrorModal}
            />
          </div>
        </div>
      )}

      <DeleteConfirmation
        isOpen={isDeletePopupOpen}
        onClose={closeDeletePopup}
        onConfirm={handleConfirmDelete}
      />

      {/* Modal zur Fehlermeldung anzeigen, wenn showErrorModal true ist */}
      {showErrorModal && (
        <IncorrectInputModalModal
          message={errorMessage} // Dynamische Nachricht übergeben
          onClose={() => setShowErrorModal(false)} // Schließt das Modal
        />
      )}

    </MainLayout>
  )
}

export default UserAdministrationPage
